import React from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import StudentForm from './StudentForm'

const StudentEditPage = () => {
  const { id } = useParams()
  const navigate = useNavigate()

  return (
    <section className="content">
      <div className="block-header">
        <div className="row">
          <div className="col-lg-7 col-md-6 col-sm-12 text-left">
            <h2>
              Öğrenci Düzenle
              <small>Öğrenci bilgilerini güncelleyin</small>
            </h2>
          </div>
          <div className="col-lg-5 col-md-6 col-sm-12">
            <button
              className="btn btn-white btn-icon btn-round float-right m-l-10"
              type="button"
              onClick={() => navigate('/students')}
              title="Geri Dön"
            >
              <i className="zmdi zmdi-arrow-left"></i>
            </button>
            <ul className="breadcrumb float-md-right">
              <li className="breadcrumb-item">
                <Link to="/dashboard">
                  <i className="zmdi zmdi-home" style={{ marginRight: '5px' }}></i> Ana Sayfa
                </Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/students">Öğrenciler</Link>
              </li>
              <li className="breadcrumb-item active">Düzenle</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row clearfix">
          <div className="col-lg-12">
            <div className="card">
              <div className="body" style={{ paddingTop: '20px' }}>
                <StudentForm
                  studentId={id}
                  mode="admin"
                  onSaved={() => navigate('/students')}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default StudentEditPage



